export const styles = theme => ({
    list: {
        margin: 0,
        padding: 0
    },
    multilineField: {
        margin: "0.5rem 0",
        background: "white"
    },
    listItem: {
        listStyleType: "none",
	    display: "flex",
	    alignItems: "center",
	    margin: "2px 0"
    },
    filename: {
        color: "transparent",
    },
   
});
